export default __webpack_public_path__ + "static/media/cypress-io-logo.c6c1de5d.png";